import { useState, useContext } from 'react';
import { AppDataContext } from "./components/AppDataContext";

export default function useNetwork(initLoading) {
    const [loading, setLoading] = useState(initLoading);
    const [networkError, setNetworkError] = useState(null);
    const context = useContext(AppDataContext);

    const addXsrfHeader = (headers) => {
        if (document.cookie != null) {
            const xsrfToken = document.cookie
                .split("; ")
                .find(row => row.startsWith("XSRF-TOKEN="));

            if (xsrfToken != null &&
                xsrfToken.length > 0 &&
                xsrfToken.split("=").length > 1) {
                const authToken = xsrfToken.split("=")[1];
                headers["X-XSRF-TOKEN"] = authToken;
            }
        }
    }

    const netRequest = async (url, postData, dontRecurse) => {
        let headers = {
            Accept: 'application/json',
        };
        if (postData != null) {
            headers['Content-Type'] = 'application/json';
        }
        if (postData != null) {
            addXsrfHeader(headers);
        }

        let request = {
            method: postData == null ? 'GET' : 'POST',
            headers: headers,
        };
        if (postData != null) {
            request["body"] = JSON.stringify(postData);
        }

        setLoading(true);
        setNetworkError(null);
        const response = await fetch(url, request);
        setLoading(false);


        let data = null;
        let isError = true;
        if (response.status == 200) {    
            data = await response.json();
            isError = false;
        } else if (response.status == 204) {
            // 204 No Content- null was returned in the data set
            isError = false;

        } else if (response.status == 400) {
            // only the first time we come through and get a 400, which is likely the XSRF token being
            // stale (perhaps a server restart), try and clear and get a new token, and try again
            if (!dontRecurse) {
                document.cookie = 'XSRF-TOKEN=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                await fetch("/api/site/GetXRF");
                return await netRequest(url, postData, true);
            } else {
                setNetworkError("BadRequest");
            }
        } else if (response.status == 401) {
            setNetworkError("Unauthorized");
        } else if (response.status == 404) {
            setNetworkError("NotFound");
        } else {
            setNetworkError("Error");
        }

        context.testSoftwareVersion(response.headers.get('SoftwareVersion'));

        return { data: data, status: response.status, isError: isError };
    };

    const netFormPost = async (url, formData, dontRecurse) => {
        let headers = {};
        addXsrfHeader(headers);
        
        let request = {
            method: 'POST',
            headers: headers,
            body: formData
        };        

        setLoading(true);
        setNetworkError(null);
        const response = await fetch(url, request);
        setLoading(false);

        let data = null;
        let isError = true;
        if (response.status == 200) {
            data = await response.json();
            isError = false;
        } else if (response.status == 204) {
            // 204 No Content- null was returned in the data set
            isError = false;

        } else if (response.status == 400) {
            // only the first time we come through and get a 400, which is likely the XSRF token being
            // stale (perhaps a server restart), try and clear and get a new token, and try again
            if (!dontRecurse) {
                document.cookie = 'XSRF-TOKEN=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
                await fetch("/api/site/GetXRF");
                return await netFormPost(url, formData, true);
            } else {
                setNetworkError("BadRequest");
            }
        } else if (response.status == 401) {
            setNetworkError("Unauthorized");
        } else if (response.status == 404) {
            setNetworkError("NotFound");
        } else {
            setNetworkError("Error");
        }

        return { data: data, status: response.status, isError: isError };
    };

    const netRenderError = () => {
        //if (networkError === "Unauthorized") {
        //    return (<Redirect to="/" />);
        //} else if (networkError === "NotFound") {
        //    return (<Redirect to="/NotFound" />);
        //}
        //return (<Redirect to="/Error" />);
    }

    return { loading, networkError, netRequest, netRenderError, netFormPost };
}
